import { OrderSection, type OrderSectionProps } from './OrderSection';

export function LabOrderSection(props: OrderSectionProps) {
  return <OrderSection kind="lab" {...props} />;
}
